import React from 'react';
import PropTypes from 'prop-types';
import {Form, Radio} from 'semantic-ui-react';

const BasicRadio = (props) => (
    <Form.Field className={props.className}>
        {props.label}
        {props.options ? props.options.map((option) => (
            <Radio key={option.key || option.value}
                   label={option.text}
                   name={props.name}
                   disabled={props.disabled || option.disabled}
                   required={props.required}
                   value={option.value}
                   checked={props.value === option.value}
                   onChange={(event, data) => props.onValueChanged(data.value)}/>
        )) : ""}
    </Form.Field>
);

BasicRadio.propTypes = {
    className: PropTypes.string,
    label: PropTypes.any,
    options: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.any,
        value: PropTypes.any.isRequired,
        text: PropTypes.string,
        disabled: PropTypes.bool
    })),
    value: PropTypes.any.isRequired,
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onValueChanged: PropTypes.func.isRequired
};

BasicRadio.defaultProps = {
    className: ''
};

export default BasicRadio;



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/Radio.jsx